<!-- src/app/common/sidebar/sidebar.component.html -->
<div
  class="sidebar-area bg-white transition"
  [ngClass]="{'active': isToggled}"
  >
  <div class="logo bg-white">
    <!-- Logo sin navegación: permanece en la misma pantalla -->
    <a class="d-flex align-items-center">
      <img src="assets/images/01.png" alt="logo-icon"> <!-- Asegúrate que la ruta a la imagen es correcta -->
      <span class="fw-extrabold">
        Growphi
      </span>
    </a>
  </div>
  <div
    class="burger-menu transition cursor-pointer"
    [ngClass]="{'active': isToggled}"
    (click)="toggle()"
    >
    <span class="top-bar transition bg-dark d-block"></span>
    <span class="middle-bar transition bg-dark d-block"></span>
    <span class="bottom-bar transition bg-dark d-block"></span>
  </div>
  <ng-scrollbar visibility="hover">
    <div class="sidebar-inner">
      <div class="sidebar-menu">
        <!-- Usamos multi="true" para permitir que varios paneles estén abiertos -->
        <mat-accordion multi="true">
          @for (item of menuItems; track item; let i = $index) {
            <!-- Llama al template recursivo para cada ítem de primer nivel -->
            <ng-container
              [ngTemplateOutlet]="menuLevelTemplate"
              [ngTemplateOutletContext]="{ $implicit: item, level: 0, index: i }"
            ></ng-container>
          }
        </mat-accordion>
      </div>
    </div>
  </ng-scrollbar>
</div>

<!-- Template Recursivo para los Ítems del Menú -->
<ng-template #menuLevelTemplate let-item let-level="level" let-index="index">
  @switch (item.type) {
    <!-- Caso: Subtítulo -->
    @case ('subtitle') {
      @if (shouldShowSubtitle(index)) {
        <span class="sub-title text-body">
          {{ item.title | translate }}
        </span>
      }
    }
    <!-- Caso: Enlace Directo -->
    @case ('link') {
      @if (hasModuleAccess(getModuleFromRoute(item.routerLink))) {
        <a
          [routerLink]="item.routerLink"
          [href]="item.isExternalLink ? item.href : undefined"
          [target]="item.isExternalLink ? '_blank' : undefined"
          [attr.rel]="item.isExternalLink ? 'noopener noreferrer' : null"
             [ngClass]="{
                  'sidebar-menu-link': level === 0,
                  'sidemenu-link': level > 0
              }"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: item.exact !== undefined ? item.exact : true }"
          (click)="handleLinkClick($event, item)"
          >
        @if (item.icon) {
          <i-feather [name]="item.icon"></i-feather>
        }
        <span class="title">
          <ng-container *ngIf="item.title.startsWith('SIDEBAR.') else plainTitle">{{ item.title | translate }}</ng-container>
          <ng-template #plainTitle>{{ item.title }}</ng-template>
        </span>
        @if (item.badge) {
          <span class="trinta-badge">
            {{ item.badge }}
          </span>
        }
        </a>
      }
    }
    <!-- Caso: Submenú (Panel de Expansión) -->
    @case ('submenu') {
      <mat-expansion-panel
        class="custom-expansion-panel"
        [(expanded)]="item.panelOpenState"> <!-- Two-way binding para el estado de expansión -->
        <mat-expansion-panel-header>
          <mat-panel-title>
            @if (item.icon) {
              <i-feather [name]="item.icon"></i-feather>
            }
            <span class="title">
              <ng-container *ngIf="item.title.startsWith('SIDEBAR.') else plainTitle">{{ item.title | translate }}</ng-container>
              <ng-template #plainTitle>{{ item.title }}</ng-template>
            </span>
            @if (item.badge) {
              <span class="trinta-badge">
                {{ item.badge }}
              </span>
            }
          </mat-panel-title> <!-- Closing tag matches nothing -->
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          @if (item.children && item.children.length > 0) {
            <ul class="sidebar-sub-menu">
              @for (child of item.children; track child) {
                <li class="sidemenu-item">
                  <!-- Llamada recursiva para los hijos del submenú -->
                  <ng-container
                    [ngTemplateOutlet]="menuLevelTemplate"
                    [ngTemplateOutletContext]="{ $implicit: child, level: level + 1 }"
                  ></ng-container>
                </li>
              }
            </ul>
          }
        </ng-template>
      </mat-expansion-panel>
    }
  }
</ng-template>
